import { defaultHttpClient } from '../../httpClient';

export const deleteProductCategoryMeasureValues = (
  productCategorySno: number,
) => {
  return defaultHttpClient.request<void>({
    method: 'DELETE',
    url: `/api/v2/members/me/product-categories/${productCategorySno}/measure-values/`,
  });
};
